if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      let protection = false;
      if (this.submitButton.classList.contains('button__drawer--protection')) protection = true;
      if (protection && this.submitButton.classList.contains('active')) return;

      // BUNDLE ADD START
      const generateRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min), 
            randomnumber = generateRandomNumber(100000, 900000);
      
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      if (!protection) this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const upsellProducts = window.productATCUpsells;
      let variantSelected = "", productSelectedID, totalFree = 0;
      if (this.querySelector('.product-variant-id')) variantSelected = this.querySelector('.product-variant-id').value;

      const quantityInput = document.querySelector(`input[name="quantity"][form="${this.form.getAttribute('id')}"]`);
      let quantityValue = 1, reload = false;
      quantityInput
        ? quantityValue = quantityInput.value
        : quantityValue = 1;
      
      const formData = new FormData(this.form);
      if (this.cart) {
        if (upsellProducts && upsellProducts.length > 0) {
          upsellProducts.forEach(product => {
            if (product.quantityBehavior === "equals") {
              if (product.trigger.includes(variantSelected) && product.quantity === quantityValue) {
                formData.append("items[][id]", product.idToAdd);
                formData.append("items[][quantity]", 1);
              }
            } else {
              if (product.trigger.includes(variantSelected) && product.quantity <= quantityValue) {
                formData.append("items[][id]", product.idToAdd);
                formData.append("items[][quantity]", 1);
              }
            }
          });
        }
        
        const items = [], 
              addItemsToBundle = (products, properties) => {
            products.forEach(product => {
                for (const id of Object.values(product)) {
                    items.push({
                        quantity: quantityValue,
                        id: parseInt(id),
                        properties: { ...properties }
                    });
                }
            });
        };

        if (this.querySelector('[name="product-id"]')) {
          productSelectedID = this.querySelector('[name="product-id"]').value;
          if (this.querySelector('[name="total_free"]')){
            totalFree = parseInt(this.querySelector('[name="total_free"]').value);
          }
        }
        if (typeof kitData != 'undefined'){
          if (kitData.product_form_id != null && kitData.product_form_id == this.form.getAttribute('id')){
            if (kitData.choosen_discount_products.length) {
                addItemsToBundle(kitData.choosen_discount_products, { _optional_kit: 'YES', _discount_percentage: 'DIS-'+kitData.discount_sc });
            }
            if (kitData.discount_products.length) {
                addItemsToBundle(kitData.discount_products, { _optional_kit: 'YES', _discount_percentage: 'DIS-'+kitData.discount_sc });
            }
            
            if (items.length) {
                items.forEach((item, index) => {
                    formData.append(`items[${totalFree}][id]`, item.id);
                    formData.append(`items[${totalFree}][quantity]`, item.quantity);
            
                    Object.entries(item.properties).forEach(([key, value]) => {
                        formData.append(`items[${totalFree}][properties][${key}]`, value);
                    });
                    totalFree = totalFree + 1;
                });
            }
            // reload = true;
         } 
       } else {
          console.log("Product without Bundle found!");
       }
        // BUNDLE ADD END
        
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        
        this.cart.setActiveElement(document.activeElement);
      }
      
      config.body = formData;

      fetch(`${routes.cart_add_url}?timestamp=${Date.now()}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else if (reload) {
            window.location = window.routes.cart_url;
          } else {
            this.cart.renderContents(response);
          }
          if (window.refreshBundleProducts != undefined) window.refreshBundleProducts();
          if (typeof $ != 'undefined') $('button.ps-sign').trigger('click');
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
            if (protection) this.submitButton.classList.add('active');
          }
          if (!protection) this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
